<template>
	<div class="addons--price">

		<div class="wrap--lg price price--btn">

			<h3>Samlet pris <strong>{{stripeAmount(totalWithoutPackaging).amount}},-</strong></h3>

			<a class="btn--primary" href="/order" @click.prevent="placeOrder" dusk="product-done" :disabled="!validated">Bestil menu</a>
		</div>

	</div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import totalCalculation from './../mixins/totalCalculation';
    export default {
        name: "total",
		computed:{
			...mapGetters({
                order:'order',
				product:'product',
				validated:'selectionsValid',
				packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',
            }),
		},
		mixins:[totalCalculation],
		methods:{
            placeOrder(){
                if(!this.validated){
                    return
                }
                this.$store.dispatch('completedProduct');
				this.$router.push({name:'order'});
            }
		},
    }
</script>

<style scoped>

</style>
